// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.Controls .query-builder-card {
  border: 1px solid #e0e0e0;
  border-radius: 8px;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
}
.Controls .query-builder-card .card-body {
  padding: 24px;
}
.Controls .header-section {
  margin-bottom: 24px;
}
.Controls .header-section .title-with-icon {
  display: flex;
  align-items: center;
  gap: 8px;
}
.Controls .header-section .title-with-icon .search-icon {
  font-size: 18px;
  color: #333;
}
.Controls .header-section .title-with-icon .title {
  font-size: 18px;
  font-weight: 600;
  color: #333;
}
.Controls .header-section .title-with-icon .info-icon {
  font-size: 14px;
  color: #666;
  cursor: pointer;
}
.Controls .date-section {
  margin-bottom: 24px;
}
.Controls .date-section .date-row {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 16px;
}
@media (max-width: 768px) {
  .Controls .date-section .date-row {
    grid-template-columns: 1fr;
  }
}
.Controls .date-section .date-group .date-label {
  display: flex;
  align-items: center;
  gap: 6px;
  font-size: 14px;
  font-weight: 500;
  color: #333;
  margin-bottom: 8px;
}
.Controls .date-section .date-group .date-label .calendar-icon {
  font-size: 14px;
  color: #666;
}
.Controls .date-section .date-group .date-input {
  border: 1px solid #d0d0d0;
  border-radius: 4px;
  padding: 8px 12px;
  font-size: 14px;
}
.Controls .date-section .date-group .date-input:focus {
  border-color: #007bff;
  box-shadow: 0 0 0 0.2rem rgba(0, 123, 255, 0.25);
}
.Controls .date-section .date-group .date-input::placeholder {
  color: #999;
}
.Controls .locations-section {
  margin-bottom: 24px;
}
.Controls .locations-section .locations-header {
  display: flex;
  align-items: center;
  gap: 6px;
  font-size: 14px;
  font-weight: 500;
  color: #333;
  margin-bottom: 16px;
}
.Controls .locations-section .locations-header .location-icon {
  font-size: 14px;
  color: #666;
}
.Controls .locations-section .location-group {
  margin-bottom: 16px;
}
.Controls .locations-section .location-group .location-label {
  font-size: 14px;
  font-weight: 500;
  color: #333;
  margin-bottom: 8px;
}
.Controls .locations-section .location-group .location-input-row {
  display: flex;
  gap: 8px;
  align-items: stretch;
}
.Controls .locations-section .location-group .location-input-row .location-input-group {
  flex: 1;
}
.Controls .locations-section .location-group .location-input-row .location-input-group:focus-within {
  box-shadow: 0 0 0 0.2rem rgba(0, 123, 255, 0.25);
  border-radius: 4px;
}
.Controls .locations-section .location-group .location-input-row .location-input-group .location-input {
  border: 1px solid #d0d0d0;
  border-right: none;
  border-radius: 4px 0 0 4px;
  padding: 8px 12px;
  font-size: 14px;
}
.Controls .locations-section .location-group .location-input-row .location-input-group .location-input:focus {
  border-color: #007bff;
  border-right: none;
  box-shadow: none;
  outline: none;
}
.Controls .locations-section .location-group .location-input-row .location-input-group .location-input::placeholder {
  color: #999;
}
.Controls .locations-section .location-group .location-input-row .location-input-group .search-btn {
  border-top: 1px solid #d0d0d0;
  border-right: 1px solid #d0d0d0;
  border-bottom: 1px solid #d0d0d0;
  border-left: none;
  border-radius: 0 4px 4px 0;
  background: transparent;
  color: #666;
  padding: 8px 12px;
  font-size: 14px;
  cursor: text;
  pointer-events: auto;
}
.Controls .locations-section .location-group .location-input-row .location-input-group .search-btn:hover, .Controls .locations-section .location-group .location-input-row .location-input-group .search-btn:focus, .Controls .locations-section .location-group .location-input-row .location-input-group .search-btn:active, .Controls .locations-section .location-group .location-input-row .location-input-group .search-btn:focus-visible {
  background: transparent !important;
  border-top: 1px solid #d0d0d0 !important;
  border-right: 1px solid #d0d0d0 !important;
  border-bottom: 1px solid #d0d0d0 !important;
  border-left: none !important;
  color: #666 !important;
  box-shadow: none !important;
  outline: none !important;
}
.Controls .locations-section .location-group .location-input-row .location-input-group .search-btn .search-small-icon {
  font-size: 12px;
  color: #666;
}
.Controls .locations-section .location-group .location-input-row .location-input-group:focus-within .location-input {
  border-color: #007bff;
}
.Controls .locations-section .location-group .location-input-row .location-input-group:focus-within .search-btn {
  border-color: #007bff;
}
.Controls .locations-section .location-group .location-input-row .location-input-group:focus-within .search-btn:hover, .Controls .locations-section .location-group .location-input-row .location-input-group:focus-within .search-btn:focus, .Controls .locations-section .location-group .location-input-row .location-input-group:focus-within .search-btn:active, .Controls .locations-section .location-group .location-input-row .location-input-group:focus-within .search-btn:focus-visible {
  background: transparent !important;
  border-top: 1px solid #007bff !important;
  border-right: 1px solid #007bff !important;
  border-bottom: 1px solid #007bff !important;
  border-left: none !important;
  color: #666 !important;
  box-shadow: none !important;
  outline: none !important;
}
.Controls .locations-section .location-group .location-input-row .add-btn-separate {
  border: 1px solid #d0d0d0;
  background: #f8f9fa;
  color: #666;
  padding: 8px 12px;
  font-size: 14px;
  font-weight: 600;
  border-radius: 4px;
  min-width: 40px;
}
.Controls .locations-section .location-group .location-input-row .add-btn-separate:hover {
  background: #e9ecef;
  border-color: #adb5bd;
}
.Controls .submit-section {
  text-align: center;
}`, "",{"version":3,"sources":["webpack://./src/features/DriveTimeTool/components/Controls/styles.scss"],"names":[],"mappings":"AACE;EACE,yBAAA;EACA,kBAAA;EACA,wCAAA;AAAJ;AAEI;EACE,aAAA;AAAN;AAIE;EACE,mBAAA;AAFJ;AAII;EACE,aAAA;EACA,mBAAA;EACA,QAAA;AAFN;AAIM;EACE,eAAA;EACA,WAAA;AAFR;AAKM;EACE,eAAA;EACA,gBAAA;EACA,WAAA;AAHR;AAMM;EACE,eAAA;EACA,WAAA;EACA,eAAA;AAJR;AASE;EACE,mBAAA;AAPJ;AASI;EACE,aAAA;EACA,8BAAA;EACA,SAAA;AAPN;AASM;EALF;IAMI,0BAAA;EANN;AACF;AAUM;EACE,aAAA;EACA,mBAAA;EACA,QAAA;EACA,eAAA;EACA,gBAAA;EACA,WAAA;EACA,kBAAA;AARR;AAUQ;EACE,eAAA;EACA,WAAA;AARV;AAYM;EACE,yBAAA;EACA,kBAAA;EACA,iBAAA;EACA,eAAA;AAVR;AAYQ;EACE,qBAAA;EACA,gDAAA;AAVV;AAaQ;EACE,WAAA;AAXV;AAiBE;EACE,mBAAA;AAfJ;AAiBI;EACE,aAAA;EACA,mBAAA;EACA,QAAA;EACA,eAAA;EACA,gBAAA;EACA,WAAA;EACA,mBAAA;AAfN;AAiBM;EACE,eAAA;EACA,WAAA;AAfR;AAmBI;EACE,mBAAA;AAjBN;AAmBM;EACE,eAAA;EACA,gBAAA;EACA,WAAA;EACA,kBAAA;AAjBR;AAoBM;EACE,aAAA;EACA,QAAA;EACA,oBAAA;AAlBR;AAoBQ;EACE,OAAA;AAlBV;AAoBU;EACE,gDAAA;EACA,kBAAA;AAlBZ;AAqBU;EACE,yBAAA;EACA,kBAAA;EACA,0BAAA;EACA,iBAAA;EACA,eAAA;AAnBZ;AAqBY;EACE,qBAAA;EACA,kBAAA;EACA,gBAAA;EACA,aAAA;AAnBd;AAsBY;EACE,WAAA;AApBd;AAwBU;EACE,6BAAA;EACA,+BAAA;EACA,gCAAA;EACA,iBAAA;EACA,0BAAA;EACA,uBAAA;EACA,WAAA;EACA,iBAAA;EACA,eAAA;EACA,YAAA;EACA,oBAAA;AAtBZ;AAwBY;EAIE,kCAAA;EACA,wCAAA;EACA,0CAAA;EACA,2CAAA;EACA,4BAAA;EACA,sBAAA;EACA,2BAAA;EACA,wBAAA;AAzBd;AA4BY;EACE,eAAA;EACA,WAAA;AA1Bd;AA8BU;EACE,qBAAA;AA5BZ;AA+BU;EACE,qBAAA;AA7BZ;AA+BY;EAIE,kCAAA;EACA,wCAAA;EACA,0CAAA;EACA,2CAAA;EACA,4BAAA;EACA,sBAAA;EACA,2BAAA;EACA,wBAAA;AAhCd;AAqCQ;EACE,yBAAA;EACA,mBAAA;EACA,WAAA;EACA,iBAAA;EACA,eAAA;EACA,gBAAA;EACA,kBAAA;EACA,eAAA;AAnCV;AAqCU;EACE,mBAAA;EACA,qBAAA;AAnCZ;AA0CE;EACE,kBAAA;AAxCJ","sourcesContent":[".Controls {\n  .query-builder-card {\n    border: 1px solid #e0e0e0;\n    border-radius: 8px;\n    box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);\n\n    .card-body {\n      padding: 24px;\n    }\n  }\n\n  .header-section {\n    margin-bottom: 24px;\n\n    .title-with-icon {\n      display: flex;\n      align-items: center;\n      gap: 8px;\n\n      .search-icon {\n        font-size: 18px;\n        color: #333;\n      }\n\n      .title {\n        font-size: 18px;\n        font-weight: 600;\n        color: #333;\n      }\n\n      .info-icon {\n        font-size: 14px;\n        color: #666;\n        cursor: pointer;\n      }\n    }\n  }\n\n  .date-section {\n    margin-bottom: 24px;\n\n    .date-row {\n      display: grid;\n      grid-template-columns: 1fr 1fr;\n      gap: 16px;\n\n      @media (max-width: 768px) {\n        grid-template-columns: 1fr;\n      }\n    }\n\n    .date-group {\n      .date-label {\n        display: flex;\n        align-items: center;\n        gap: 6px;\n        font-size: 14px;\n        font-weight: 500;\n        color: #333;\n        margin-bottom: 8px;\n\n        .calendar-icon {\n          font-size: 14px;\n          color: #666;\n        }\n      }\n\n      .date-input {\n        border: 1px solid #d0d0d0;\n        border-radius: 4px;\n        padding: 8px 12px;\n        font-size: 14px;\n\n        &:focus {\n          border-color: #007bff;\n          box-shadow: 0 0 0 0.2rem rgba(0, 123, 255, 0.25);\n        }\n\n        &::placeholder {\n          color: #999;\n        }\n      }\n    }\n  }\n\n  .locations-section {\n    margin-bottom: 24px;\n\n    .locations-header {\n      display: flex;\n      align-items: center;\n      gap: 6px;\n      font-size: 14px;\n      font-weight: 500;\n      color: #333;\n      margin-bottom: 16px;\n\n      .location-icon {\n        font-size: 14px;\n        color: #666;\n      }\n    }\n\n    .location-group {\n      margin-bottom: 16px;\n\n      .location-label {\n        font-size: 14px;\n        font-weight: 500;\n        color: #333;\n        margin-bottom: 8px;\n      }\n\n      .location-input-row {\n        display: flex;\n        gap: 8px;\n        align-items: stretch;\n\n        .location-input-group {\n          flex: 1;\n\n          &:focus-within {\n            box-shadow: 0 0 0 0.2rem rgba(0, 123, 255, 0.25);\n            border-radius: 4px;\n          }\n\n          .location-input {\n            border: 1px solid #d0d0d0;\n            border-right: none;\n            border-radius: 4px 0 0 4px;\n            padding: 8px 12px;\n            font-size: 14px;\n\n            &:focus {\n              border-color: #007bff;\n              border-right: none;\n              box-shadow: none;\n              outline: none;\n            }\n\n            &::placeholder {\n              color: #999;\n            }\n          }\n\n          .search-btn {\n            border-top: 1px solid #d0d0d0;\n            border-right: 1px solid #d0d0d0;\n            border-bottom: 1px solid #d0d0d0;\n            border-left: none;\n            border-radius: 0 4px 4px 0;\n            background: transparent;\n            color: #666;\n            padding: 8px 12px;\n            font-size: 14px;\n            cursor: text;\n            pointer-events: auto;\n\n            &:hover,\n            &:focus,\n            &:active,\n            &:focus-visible {\n              background: transparent !important;\n              border-top: 1px solid #d0d0d0 !important;\n              border-right: 1px solid #d0d0d0 !important;\n              border-bottom: 1px solid #d0d0d0 !important;\n              border-left: none !important;\n              color: #666 !important;\n              box-shadow: none !important;\n              outline: none !important;\n            }\n\n            .search-small-icon {\n              font-size: 12px;\n              color: #666;\n            }\n          }\n\n          &:focus-within .location-input {\n            border-color: #007bff;\n          }\n\n          &:focus-within .search-btn {\n            border-color: #007bff;\n\n            &:hover,\n            &:focus,\n            &:active,\n            &:focus-visible {\n              background: transparent !important;\n              border-top: 1px solid #007bff !important;\n              border-right: 1px solid #007bff !important;\n              border-bottom: 1px solid #007bff !important;\n              border-left: none !important;\n              color: #666 !important;\n              box-shadow: none !important;\n              outline: none !important;\n            }\n          }\n        }\n\n        .add-btn-separate {\n          border: 1px solid #d0d0d0;\n          background: #f8f9fa;\n          color: #666;\n          padding: 8px 12px;\n          font-size: 14px;\n          font-weight: 600;\n          border-radius: 4px;\n          min-width: 40px;\n\n          &:hover {\n            background: #e9ecef;\n            border-color: #adb5bd;\n          }\n        }\n      }\n    }\n  }\n\n  .submit-section {\n    text-align: center;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
